// extracted by mini-css-extract-plugin
export default {"desc":"Description_desc__4KXZP","desc1":"Description_desc1__nlbho","desc2":"Description_desc2__WYPba","line":"Description_line__rsEpF"};